import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "print",
  "use": "print-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"print\"><path d=\"M463 180c0-5-4-9-9-9h-67V61c0-5-5-10-10-10H135c-5 0-10 5-10 10v110H58c-5 0-9 4-9 9v188c0 5 4 10 9 10h67v-79h262v79h67c5 0 9-5 9-10V180zm-102 33H151V86c0-5 4-9 9-9h192c5 0 9 4 9 9v127zM152 451c0 5 4 10 9 10h190c5 0 9-5 9-10V325H152z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/print.svg
// module id = 207
// module chunks = 0